import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { makeHqSalesData, makeSalesHeader } from '../../utils/eis-statics-data';
import * as staticsApi from '../../lib/api/statics';
import SalesManageStaticsHeadquarterTable from '../../components/sales-manage-statics/SalesManageStaticsHeadquarterTable';

const SalesManageStaticsHeadquarterContainer = ({
  selectedYear,
  selectedCompany,
  searchData,
  tableRef,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  // const onLoadData = async () => {
  //   setLoading(true);

  //   try {
  //     const loadedHeaders = makeSalesHeader();
  //     setHeaderRows(loadedHeaders);
  //     const res = await staticsApi.getHqTaxbillStatics(
  //       selectedYear,
  //       selectedCompany,
  //     );

  //     if (res.data.list) {
  //       setData(res.data.list);
  //     }
  //   } catch (err) {
  //     let message =
  //       typeof err.response !== 'undefined'
  //         ? err.response.data.message
  //         : err.message;
  //     enqueueSnackbar(message, {
  //       variant: 'error',
  //     });
  //   }
  //   setLoading(false);
  // };

  const onLoadData = () => {
    const loadedHeaders = makeSalesHeader();

    setHeaderRows(loadedHeaders);

    const tempData = makeHqSalesData();
    setData(tempData);
    console.log(JSON.stringify(tempData));
  };

  useEffect(() => {
    if (searchData) {
      onLoadData();
    }
  }, [searchData]);

  return (
    <SalesManageStaticsHeadquarterTable
      data={data}
      loading={loading}
      selectedYear={selectedYear}
      selectedCompany={selectedCompany}
      headerRows={headerRows}
      tableRef={tableRef}
    />
  );
};

export default SalesManageStaticsHeadquarterContainer;
